<template>
  <div class="about-us awards" id="awards">
    <header class="page-header" data-aos="fade-up">
      <div class="video-container">
        <video class="header-video" src="static/img/about-us/falcon.mp4" autoplay loop></video>
      </div>
      <div class="container">
        <div v-html="$t('privacy.title')" class="heading-text" data-aos="fade-up">
        </div>
      </div>
      <a @click="smoothScroll" href="#top" :data-scroll-offset="scrollOffset" class="more-about-us white"
         data-aos="fade-up"><span>{{$t('privacy.see')}}</span></a>
    </header>
    <div class="product">
      <div class="why-us-solution" id="top">
        <div class="elements">

          <div class="element clearfix">
            <div>
              <div>
                <p class="header-text" v-if="lang === 'pl'">
                  BIOSECO Sp. z o.o. - Polityka Prywatności i RODO
                </p>
                <p class="header-text" v-if="lang !== 'pl'">
                  BIOSECO Sp. z o.o. Privacy Policy
                </p>
                <div class="text" v-if="lang === 'pl'">
                  Zgodnie z art. 13 Rozporządzenia Parlamentu Europejskiego i Rady (UE) nr 2016/679 z dnia 27.04.2016 r. (dalej RODO), informujemy Państwa o następujących kwestiach: <br/><br/>
                </div>
                <div class="text" v-if="lang !== 'pl'">
                  Pursuant to Article 13 of Regulation (EU) 2016/679 of the European Parliament and of the Council of 27 April 2016 (hereinafter “GDPR”), we hereby inform you of the following: <br/><br/>
                </div>
                <div v-if="lang === 'pl'">
                  <ul class="text" >
                    <li> 1. Administratorem Państwa danych osobowych jest firma Bioseco SA, z siedzibą w Gdańsku (80-298), przy ul. Budowlanych 68.</li>
                    <li> 2. Wszelkie pytania dotyczące sposobu i zakresu przetwarzania Państwa danych osobowych oraz zakresu przysługujących Państwu uprawnień, prosimy kierować na adres: jacek.witt@bioseco.com.</li>
                    <li> 3. Państwa dane osobowe przetwarzamy w celu zawarcia umowy, na podstawie art. 6 ust. 1 lit. b RODO, a także na podstawie art. 6 ust. 1 lit. c RODO, w związku z obowiązkiem prawnym wynikającym z Ustawy z dnia 14.06.2024 r. o ochronie sygnalistów oraz art. 6 ust. 1 lit. f RODO, tzn. wykorzystując prawnie uzasadniony interes Administratora, jakim jest: 
                      <ol>(a) kontakt telefoniczny bądź mailowy z osobą, która skontaktuje się z nami poprzez adres e-mail umieszczony na stronie: <router-link to="/contact">https://bioseco.com/contact</router-link>,</ol>
                      <ol>(b) przyjmowanie, weryfikowanie i wyjaśnianie zgłoszeń dotyczących naruszeń prawa.</ol>
                    </li>
                    <li> 4. Mogą Państwo zwrócić się do nas z żądaniem dostępu do swoich danych, ich sprostowania, przeniesienia, usunięcia, ograniczenia przetwarzania, jak również wnieść sprzeciw wobec ich dalszego przetwarzania w każdym momencie. W tym celu, oraz w każdym innym związanym z przetwarzaniem danych osobowych, należy kontaktować się z nami mailowo, wysyłając wiadomość na adres e-mail, bądź pocztą tradycyjną, wysyłając je na adresy wskazane w punkcie 1 powyżej. Każde zgłoszenie, zgodnie z przepisami prawa, jest przez nas rejestrowane i rozpatrywane, a jeżeli będzie możliwość jego spełnienia, zostaną Państwo poinformowani o wyniku realizacji zgłoszenia.
                    </li>
                    <li> 5. Dane osobowe, które nam Państwo powierzacie, przechowywane są w bazie kontrahentów, kontaktów oraz sygnalistów. Bazy te są odpowiednio zabezpieczone tak, aby nie dostały się w niepowołane ręce, ani nie zostały utracone. Dane osobowe w nich zawarte będziemy przetwarzać do momentu ustania celu przetwarzania, tj. do zakończenia współpracy bądź kontaktu, albo do chwili wycofania przez Państwo zgody na ich przetwarzanie, po czym będziemy je archiwizować przez 3 lata. W przypadku danych osobowych sygnalistów i osób wymienionych w zgłoszeniu naruszenia przepisów prawa, będą one przetwarzanie przez 3 lata od chwili wpłynięcia zgłoszenia.
                    </li>
                    <li> 6. Odbiorcami Państwa danych osobowych będą jedynie podmioty uprawnione do ich przetwarzania w związku z realizacją umowy bądź innego celu przetwarzania.
                    </li>
                    <li> 7. Nie będziemy przekazywać Państwa danych osobowych do państw trzecich, tzn. poza obszar Europejskiego Obszaru Gospodarczego.</li>
                    <li> 8. Państwa dane osobowe nie będą podlegały zautomatyzowanemu procesowi podejmowania decyzji, w tym tzw. profilowaniu.
                    </li>
                    <li> 9. W przypadku zidentyfikowania nieprawidłowości w przetwarzaniu danych osobowych przez Administratora, mają Państwo prawo skierować skargę do Prezesa Urzędu Ochrony Danych Osobowych, z siedzibą w Warszawie (00-923), przy ul. Stawki 2.
                    </li>
                    <li> 10. Podanie danych osobowych jest dobrowolne, jednakże odmowa ich podania może skutkować odmową kontaktu i/lub nawiązania współpracy, a także brakiem możliwości potwierdzenia otrzymania zgłoszenia sygnalisty w zakresie naruszenia przepisów prawa.
                    </li>
                  </ul>
                </div>
                  <div v-if="lang !== 'pl'">
                  <ul class="text" >
                    <li>1. The controller of your personal data is Bioseco SA, with its registered office in Gdańsk (80-298), at 68 Budowlanych Street.</li>
                    <li>2. Any questions regarding the method and scope of the processing of your personal data and your rights should be directed to: jacek.witt@bioseco.com.</li>
                    <li>3. We process your personal data for the purpose of concluding a contract pursuant to Article 6(1)(b) of the GDPR, and also pursuant to Article 6(1)(c) of the GDPR, due to a legal obligation arising from the Act of 14 June 2024 on the protection of whistleblowers, and pursuant to Article 6(1)(f) of the GDPR, meaning the legitimate interests of the Controller, including:
                      <ol>(a) contacting a person by phone or email who reaches out via the email address provided at: <router-link to="/contact">https://bioseco.com/contact</router-link>,</ol>
                      <ol>(b) receiving, verifying, and clarifying reports regarding legal violations.</ol>  
                    </li>
                    <li>4. You may request access to your data, rectification, portability, erasure, restriction of processing, and object to further processing at any time. For these matters and any others related to personal data processing, please contact us by email or traditional mail using the contact details provided in point 1 above. Each request is registered and considered in accordance with legal provisions. If your request can be fulfilled, you will be informed of the result.</li>
                    <li>5. The personal data you entrust to us is stored in a database of contractors, contacts, and whistleblowers. These databases are properly secured against unauthorized access or loss. We will process the data until the purpose of processing ceases, i.e., the end of cooperation or contact, or until consent is withdrawn. Afterward, it will be archived for 3 years. Personal data of whistleblowers and persons mentioned in legal violation reports will be processed for 3 years from the date the report is received.</li>
                    <li>6. The recipients of your personal data will be only entities authorized to process it in connection with the fulfillment of a contract or other processing purpose.</li>
                    <li>7. We will not transfer your personal data to third countries, i.e., outside the European Economic Area.</li>
                    <li>8. Your personal data will not be subject to automated decision-making, including profiling.</li>
                    <li>9. If you identify any irregularities in the processing of your personal data by the Controller, you have the right to file a complaint with the President of the Personal Data Protection Office, located in Warsaw (00-923), at 2 Stawki Street.</li>
                    <li>10. Providing personal data is voluntary; however, failure to provide it may result in the refusal of contact and/or the establishment of cooperation, as well as the inability to confirm receipt of a whistleblower's report on a legal violation.</li>
                  </ul>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <footer-main/>
  </div>
</template>

<script>
  import FooterMain from '../components/FooterMain';
  import FooterMoreInformation from '../components/FooterMoreInformation';
  import MediaBox from '../components/MediaBox';
  import smoothScroll from '../helpers/SmoothScroll';

  export default {
    name: 'awards',
    data() {
      return {
        popupActivo: false,
        popupActivo2: false,
      }
    },
    props: [],
    methods: {},
    components: {
      FooterMain,
      FooterMoreInformation,
      MediaBox
    },
    computed: {
      lang: () => {
        return store.state.lang;
      },
      scrollOffset: () => {
        return window.innerWidth > 980 ? 130 : 90;
      },
      smoothScroll: () => smoothScroll
    }
  }
</script>

<style scoped="">
  .show-mobile {
    display: none;
  }

  .about-us.awards .heading {
    margin-top: 10px;
  }

  .awards header.page-header {
    min-height: 320px;
  }

  .awards .product .why-us-solution .elements .element {
    display: flex;
    flex-direction: row;
    margin-bottom: 50px;
  }

  .header-text {
    font-size: 24px;
    line-height: 1.4em;
    text-align: center;
    margin-bottom: 20px;
  }

  .text {
    font-size: 18px;
    line-height: 1.4em;
  }
  .text li{
    margin-bottom: 10px;
  }
  .text ol{
    padding-left: 30px;
  }

  .awards .product .why-us-solution .elements .element .text-box .heading .text {
    font-size: 18px;
  }

  .awards .product .why-us-solution .elements .element .text-box em {
    display: block;
    font-size: 18px;
    line-height: 1.6em;
    color: #f2b667;
  }

  .awards .product .why-us-solution .elements .element .text-box {
    margin-top: 10px;
  }

  .awards .product .why-us-solution .elements .element .text-box p {
    margin: 20px 0;
    padding: 0 20px;
  }

  .awards .product .why-us-solution .elements .element img {
    max-width: 400px;
    max-height: 240px;
  }

  @media (max-width: 980px) {
    .product .why-us-solution .elements .element .text-box .heading .hexagon {
      display: none;
    }

    .product .why-us-solution .elements .element .text-box .heading {
      width: 90%;
    }
  }

  @media (max-width: 780px) {
    .awards .product .why-us-solution .elements .element {
      flex-direction: column;
    }

    .show-mobile {
      display: block;
    }

    .hide-mobile {
      display: none;
    }

    .product .why-us-solution .elements .element .text-box .heading {
      width: 100%;
    }

    .product .why-us-solution .elements .element .text-box .heading .text {
      text-align: left;
      width: 100%;
      margin-left: 10px;
    }

    .awards .product .why-us-solution .elements .element img {
      width: 100%;
    }
  }

</style>



// WEBPACK FOOTER //
// Privacy.vue?4ec48e2e